import { YinzCamAPI, YinzCamAPIRequest } from 'yinzcam-api';
import { register } from 'yinzcam-registry';
import { APP_SERVER_REGISTRY } from './constants';
import { YinzCamNBAAppServer } from './YinzCamNBAAppServer';

@register(APP_SERVER_REGISTRY, 'wnba')
export class YinzCamWNBAAppServer extends YinzCamNBAAppServer {
  
  public constructor(api: YinzCamAPI) {
    super(api);
  }
}
